// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1BjUr","question":"Question_question__r4sfh","description":"Question_description__1vpCH"};